/**
 * Page 6: preferences saved.
 *
 * Deliberately a page rather than a toast. It is the end of a short task and the
 * handoff gives it a next step, which a toast cannot carry.
 */

import React from 'react';
import { Link, useParams } from 'react-router-dom';

import TrialShell from './TrialShell';
import { useFocusHeading } from './useTrialPage';
import { EVENTS, track } from '../../analytics/campaignAnalytics';

export default function SavedPage() {
  const { token } = useParams();
  const heading = useFocusHeading(true);

  return (
    <TrialShell
      token={token}
      active="refine"
      onContactClick={() => track(EVENTS.CONTACT_CLICKED)}
      onSiteClick={() => track(EVENTS.SITE_LINK_CLICKED)}
    >
      <main className="tr-main tr-main--centred">
        <div className="tr-wrap tr-wrap--narrow">
          <p aria-hidden="true" style={{ fontSize: 40, lineHeight: 1, color: '#00aeef' }}>&#10003;</p>
          {/*
            * role="status" so the change is announced rather than only seen. The
            * heading also takes focus, which is what tells a screen reader user
            * the navigation completed.
            */}
          <h1 className="tr-h1" role="status" tabIndex={-1} ref={heading} style={{ marginTop: 16 }}>
            Your preferences have been saved.
          </h1>
          {/*
            * Says what is actually happening now, rather than deferring to some
            * unspecified "next" list. Since 29 October 2026 a save re-infers
            * the feed's criteria and queues a run, and the new list is emailed
            * when it completes, so this is a promise the system now keeps.
            */}
          <p className="tr-lede">
            We&rsquo;re building a new list from your updated interests. It will arrive by email
            in a few minutes.
          </p>
          <Link
            className="tr-btn tr-btn--primary tr-btn--lg tr-btn--block-mobile"
            to={`/trial/feed/${token}`}
            style={{ marginTop: 28 }}
          >
            Back to my news feed
          </Link>
        </div>
      </main>
    </TrialShell>
  );
}
